import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { requestForToken, unregisterToken } from "../../notificationApi";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await axios.post(
        "https://157.245.99.9/api/auth/admin-login/",
        { email, password }
      );

      console.log("✅ Login response:", response.data);

      // Save tokens
      const { access, refresh } = response.data.tokens;
      localStorage.setItem("authTokens", JSON.stringify(response.data));
      localStorage.setItem("accessToken", access);
      localStorage.setItem("refreshToken", refresh);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      try {
        await requestForToken();
        console.log("✅ FCM token generated after login.");
      } catch (fcmErr) {
        console.error("⚠️ Failed to generate FCM token:", fcmErr);
      }

      return response.data;
    } catch (error) {
      console.error("❌ Login failed:", error.response?.data || error.message);
      return thunkAPI.rejectWithValue(
        error.response?.data?.detail || "Login failed"
      );
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, thunkAPI) => {
    try {
      await unregisterToken();
      
      localStorage.removeItem("authTokens");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      
      console.log("✅ Logout successful");
      return null;
    } catch (error) {
      console.error("❌ Logout error:", error);
      return thunkAPI.rejectWithValue("Logout failed");
    }
  }
);
